export default __webpack_public_path__ + "static/char-v-12-43b6b5885d6612ff7d05177e566f4cd9.mp4";